import { render, staticRenderFns } from "./dictaBERT.vue?vue&type=template&id=104ec427"
import script from "./dictaBERT.vue?vue&type=script&lang=js"
export * from "./dictaBERT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports